"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TopBar = void 0;
var vue_1 = require("vue");
var PlayerInfo_1 = require("./overview/PlayerInfo");
var PreferencesManager_1 = require("./PreferencesManager");
exports.TopBar = vue_1.default.component('top-bar', {
    props: {
        player: {
            type: Object,
        },
    },
    components: {
        PlayerInfo: PlayerInfo_1.PlayerInfo,
    },
    data: function () {
        return {
            componentKey: 0,
        };
    },
    methods: {
        forceRerender: function () {
            this.componentKey += 1;
        },
        toggleBar: function () {
            PreferencesManager_1.PreferencesManager.save('hide_top_bar', !this.isExpanded(), true);
            this.forceRerender();
        },
        isExpanded: function () {
            return PreferencesManager_1.PreferencesManager.loadBoolean('hide_top_bar');
        },
        formatCssClass: function () {
            var cssClasses = ['top-bar'];
            if (!this.isExpanded()) {
                cssClasses.push('top-bar-collapsed');
            }
            return cssClasses.join(' ');
        },
    },
    template: "\n    <div :class=\"formatCssClass()\" :key=\"componentKey\">\n      <PlayerInfo v-show=\"isExpanded()\" :player=\"player\" :activePlayer=\"player\" actionLabel=\"\" :playerIndex=\"0\" :hideZeroTags=\"true\"/>\n      <div class=\"top-bar-collapser\" v-on:click=\"toggleBar()\">\n        <img src=\"/assets/arrows_left.png\">\n      </div>\n    </div>\n  ",
});
//# sourceMappingURL=TopBar.js.map